import React from 'react';
import PropTypes from 'prop-types';
import UBCFooter from '../../components/UBCFooter';
import Header from '../../components/Header';
import style from './style.css';

export default class MainLayout extends React.Component {
    static propTypes = {
        children: PropTypes.node,
        className: PropTypes.string,
    };

    static defaultProps = {
        className: 'container',
    };

    render() {
        return (
            <div className={style.wrapper}>
                <div className={style.header}>
                    <Header className={this.props.className} />
                </div>

                <div className={style.body}>
                    <div className={this.props.className}>{this.props.children}</div>
                </div>

                <div className={style.footer}>
                    <UBCFooter className={this.props.className} />
                </div>
            </div>
        );
    }
}
